import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body scroll-wrapper" }
const _hoisted_2 = { class: "input-row form-group" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "input-row form-group" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "select-options-wr" }
const _hoisted_13 = { class: "options-wr" }
const _hoisted_14 = { class: "controls" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: ['select-builder-quote-modal']
  }, {
    content: _withCtx(() => [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("div", { class: "modal-title" }, "Send us a message"),
        _createElementVNode("div", { class: "line" })
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label bold" }, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
              placeholder: "First Name"
            }, null, 512), [
              [_vModelText, $setup.form.firstName]
            ]),
            ($setup.v$.firstName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.firstName.required.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label bold" }, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
              placeholder: "Last Name"
            }, null, 512), [
              [_vModelText, $setup.form.lastName]
            ]),
            ($setup.v$.lastName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.v$.lastName.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label bold" }, "Phone", -1)),
            _createVNode($setup["Cleave"], {
              class: "input-default",
              placeholder: "0412 345 678",
              modelValue: $setup.form.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.phone) = $event)),
              options: $setup.phoneNumberOption($setup.form.phone)
            }, null, 8, ["modelValue", "options"]),
            ($setup.v$.phone.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label bold" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.email) = $event)),
              type: "email",
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, $setup.form.email]
            ]),
            ($setup.v$.email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.v$.email.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label bold" }, "Message", -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "input-default scroll-wrapper",
              placeholder: "Message",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.message) = $event))
            }, null, 512), [
              [_vModelText, $setup.form.message]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (!$setup.isLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button default primary large long",
              disabled: $setup.isLoading,
              onClick: $setup.submit
            }, "Send message", 8, _hoisted_15))
          : (_openBlock(), _createElementBlock("div", _hoisted_16)),
        _createElementVNode("button", {
          class: "button-cancel-border default large",
          onClick: $setup.onClose
        }, "Cancel")
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}